import { MEAL_PLAN_CALENDAR_DAY, MEAL_PLAN_ITEM, MEAL_PLAN_PAGE } from 'analytics/constants/ids';

import { basicTrackDecorator, trackNewScreenLoad } from 'services/Analytics';

export const trackMealPlanPageLoad = () => trackNewScreenLoad(MEAL_PLAN_PAGE);

export const trackMealCalendarClick = ({
    targetDay,
    hasMealsAvailable,
}: {
    targetDay: number;
    hasMealsAvailable: boolean;
}) =>
    basicTrackDecorator(`${MEAL_PLAN_CALENDAR_DAY}__click`, undefined, undefined, {
        target_day: targetDay,
        has_meals_available: hasMealsAvailable,
    });

export const trackMealItemClick = ({ mealType }: { mealType: string }) =>
    basicTrackDecorator(`${MEAL_PLAN_ITEM}__click`, undefined, undefined, {
        meal_type: mealType,
    });

export const trackMealPageLoad = (dayIndex: number, status: string) =>
    basicTrackDecorator(`${MEAL_PLAN_PAGE}__load`, undefined, undefined, {
        target_day_number: dayIndex,
        status,
    });
